// Resolve.
export const SET_SECURE_AUTH_DATA = 'SET_SECURE_AUTH_DATA';
